import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signin-layout',
  templateUrl: './signin-layout.component.html',
  styleUrls: []
})
export class SigninLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
